// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2pyt_","name":"Header_name__1PFDm","birthday":"Header_birthday__2CkpY","skeleton":"Header_skeleton__13xsL"};